import axios from "axios";

const jskyApi = axios.create({
    baseURL: process.env.VUE_APP_JSKY_URL
});
jskyApi.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);
// Add language header dynamically
jskyApi.interceptors.request.use((config) => {
    const lang = localStorage.getItem('locale') || 'en';
    config.headers['Accept-Language'] = lang;
    return config;
});
export default jskyApi;